export default function ({ route, redirect }) {
    const allowedRoutes = ['/roadshow-taiwan', '/roadshow-taiwan-2', '/roadshow-singapore', '/hu/roadshow-budapest', '/ar/blog/gcc-residents', '/roadshow-hong-kong', '/zh/roadshow-hong-kong', '/roadshow-erbil', '/ku/roadshow-erbil', '/it/roadshow-italy'];    
  
    if (!allowedRoutes.includes(route.path)) {
      return redirect('/roadshow-taiwan');
    }
  }